import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  DELETE_ROLE_ACTION_TYPE,
  INSERT_UPDATE_ROLES_ACTION_TYPE,
  ROLES_LIST_ACTION_TYPE,
  ROLE_DETAILS_ACTION_TYPE,
  headers,
  insertUpdateRoleUrl,
  roleDeleteUrl,
  roleDetailUrl,
  roleListUrl,
} from "../../utils/constants";

export const role_list_action =
  (Name, StatusID) => async (dispatch) => {
    try {
      const mapdata = {
        userId:
          sessionStorage.getItem("userId") != ""
            ? sessionStorage.getItem("userId")
            : null,
        Name: Name.toString().trim(),
        StatusID: StatusID,
      };
      const params = {
        userId: mapdata.userId === "" ? null : mapdata.userId,
        Name: mapdata.Name === "" ? null : mapdata.Name,
        StatusID: mapdata.StatusID === "" ? null : mapdata.StatusID,
      };
      console.log("Roles mapdata...", mapdata);
      const res = await axiosGet(roleListUrl, params,headers);
      console.log("Roles", res);
      dispatch({
        type: ROLES_LIST_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const role_detail_action = (roleID) => async (dispatch) => {
  try {
    const params = {
      userId: sessionStorage.getItem("userId") != "" ? sessionStorage.getItem("userId") : null,
      roleID: roleID,
    };
    console.log("Roles detail mapdata...", params);
    const res = await axiosGet(roleDetailUrl, params,headers);
    console.log("detailsRoles", res);
    const { data, error } = res;
    const roleDetails = data.recordsets[0][0];
    const moduleAccess = data.recordsets[1];
    console.log(moduleAccess,"moduleAccess")
    const reportAccess = data.recordsets[2];
    console.log(reportAccess,"reportAccess")
    const sysInfo = data.recordsets[3][0];

    const modifiedRes = {
      roleDetails: roleDetails,
      moduleAccess: moduleAccess,
      reportAccess: reportAccess,
      sysInfo:sysInfo,
      error: error,
    };

    dispatch({
      type: ROLE_DETAILS_ACTION_TYPE,
      payload: modifiedRes,
    });

    return modifiedRes;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const role_insertUpdate_action =
  ( roleID, Name, Description, moduleAccessList, reportAccessList,Status) =>
    async (dispatch) => {
      try {
        const mapdata = {
          userId:
          sessionStorage.getItem("userId") != ""
            ? sessionStorage.getItem("userId")
            : null,
          roleID: roleID ? roleID.toString().trim() : null,
          Name: Name.toString().trim(),
          Description: Description.toString().trim(),
          moduleAccessList: moduleAccessList,
          reportAccessList: reportAccessList,Status:Status
        };
        console.log("Role add mapdata...", mapdata);

        const res = await axiosPost(insertUpdateRoleUrl, mapdata,headers);
        dispatch({
          type: INSERT_UPDATE_ROLES_ACTION_TYPE,
          payload: res,
        });
        return Promise.resolve(res);
      } catch (err) {
        return Promise.reject(err);
      }
    };

export const role_delete_action = ( roleID) => async (dispatch) => {
  try {
    const mapdata = {
      userId:
          sessionStorage.getItem("userId") != ""
            ? sessionStorage.getItem("userId")
            : null,
      roleID: roleID ? roleID.toString().trim() : "",
    };

    const res = await axiosGet(roleDeleteUrl, mapdata,headers);
    dispatch({
      type: DELETE_ROLE_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};
